import React from "react";
import { Box, Typography } from "@mui/material";
import ScrollableWrapper from "./ScrollableWrapper";

interface ValidationErrorDisplayProps {
  errors: string[];
}

const ValidationErrorDisplay: React.FC<ValidationErrorDisplayProps> = ({
  errors,
}) => {
  if (errors.length === 0) return null;

  return (
    <Box
      sx={{
        maxHeight: "200px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ScrollableWrapper customPadding="0px">
        <Box
          sx={{
            backgroundColor: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: "8px",
            padding: "12px",
          }}
        >
          {errors.map((error, index) => (
            <Typography
              key={index}
              sx={{
                fontFamily: "var(--font-Medium)",
                fontSize: "12px",
                color: "#dc2626",
                lineHeight: "16px",
                margin: "2px 0",
              }}
            >
              • {error}
            </Typography>
          ))}
        </Box>
      </ScrollableWrapper>
    </Box>
  );
};

export default ValidationErrorDisplay;
